import { isNull } from '../misc/Utils'

export default {
    data: () => ({
        circleProgress: [],
    }),
    async mounted() {
        this.circleProgress = document.querySelectorAll('.circle-link')

        this.$nextTick(() => {
            if (!isNull(this.circleProgress)) {
                this.handleCircleProgress()
            }
        })
    },
    methods: {
        handleCircleProgress() {
            Array.prototype.forEach.call(this.circleProgress, (element) => {
                const circleFill = element.querySelector('.btn-circle__progress--fill')
                const progress = element.querySelector('.btn-circle__progress')
                const base = circleFill.r.baseVal.value
                const calculate = 2 * Math.PI * base

                circleFill.style.setProperty('--initialStroke', calculate)

                element.addEventListener('mouseover', () => {
                    circleFill.style.setProperty('--transitionDuration', ''.concat(1500, 'ms'))
                    setTimeout(() => {
                        return (circleFill.style.strokeDashoffset = 0)
                    }, 100)
                })

                element.addEventListener('mouseout', () => {
                    circleFill.style.setProperty('--transitionDuration', ''.concat(1500, 'ms'))
                    setTimeout(() => {
                        return (circleFill.style.strokeDashoffset = calculate)
                    }, 100)
                })
            })
        },
    },
}
